import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import React, { useCallback } from 'react';
import { ITime } from '../../types/time';
import dayjs, { Dayjs } from 'dayjs';

function formatDate(date: Date, time: ITime): Date {
  const formattedDate = new Date(date);
  formattedDate.setHours(time.hour);
  formattedDate.setMinutes(time.minute);
  formattedDate.setSeconds(time.second);
  return formattedDate;
}

type CustomDatePickerProps = {
  label: string;
  time: ITime;
  value?: string;
  error?: string;
  onTouched?: () => void;
  onChange: (value: Date | undefined) => void;
};

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  time,
  value,
  error,
  onTouched,
  onChange,
}) => {
  const onDateChange = useCallback(
    (date: Dayjs | null) => {
      if (date?.isValid()) {
        onChange(formatDate(date.toDate(), time));
        return;
      }
      onChange(undefined);
    },
    [onChange, time]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div data-cy={'datePicker_' + label}>
        <DatePicker
          label={label}
          value={value ? dayjs(value) : null}
          format="DD/MM/YYYY"
          minDate={dayjs('2000-01-01')}
          shouldDisableDate={(day) => (day as Dayjs).isBefore(dayjs('2000-01-01'), 'day')}
          onChange={(value) => onDateChange(value as dayjs.Dayjs | null)}
          onOpen={onTouched}
          slotProps={{
            textField: {
              onBlur: onTouched,
              error: !!error,
              helperText: error,
              inputProps: {
                type: 'tel',
              },
            },
            layout: {
              className: 'MuiCalendarPicker-root',
            },
          }}
        />
      </div>
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
